import React from 'react'

type Props = {
    
}

function RepotIcon(props?: any) {
    const {color,...otherProps} = props
  return (
    <svg {...otherProps}  width="28"
      height="28"  viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...otherProps}>
<path d="M21.1562 6.88672V8.01465H14.6787C12.9398 8.01469 11.5344 9.42035 11.5342 11.1592V35.0811H10.3867V11.1787C10.3868 8.81572 12.3157 6.88676 14.6787 6.88672H21.1562Z" fill={"currentColor"} stroke={"currentColor"} stroke-width="0.227437" stroke-miterlimit="10"/>
<path d="M30.7412 8.65039V32.5713C30.7412 34.9343 28.8113 36.8633 26.4482 36.8633H26.1738L26.1924 36.8447H19.9902V35.7158H26.4678C28.2067 35.7157 29.6123 34.3103 29.6123 32.5713V8.65039H30.7412Z" fill={"currentColor"} stroke={"currentColor"} stroke-width="0.227437" stroke-miterlimit="10"/>
<path d="M25.2583 13.73V14.8579H15.8882V13.73H25.2583Z" fill={"currentColor"} stroke={"currentColor"} stroke-width="0.227437" stroke-miterlimit="10"/>
<path d="M25.2583 17.832V18.96H15.8882V17.832H25.2583Z" fill={"currentColor"} stroke={"currentColor"} stroke-width="0.227437" stroke-miterlimit="10"/>
<path d="M25.2583 21.915V23.043H15.8882V21.915H25.2583Z" fill={"currentColor"} stroke={"currentColor"} stroke-width="0.227437" stroke-miterlimit="10"/>
<path d="M25.2583 26.0173V27.1453H15.8882V26.0173H25.2583Z" fill={"currentColor"} stroke={"currentColor"} stroke-width="0.227437" stroke-miterlimit="10"/>
<path d="M25.2583 30.1003V31.2283H15.8882V30.1003H25.2583Z" fill={"currentColor"} stroke={"currentColor"} stroke-width="0.227437" stroke-miterlimit="10"/>
</svg>

  )
}

export default RepotIcon